export const isExternalUrl = (url) => url?.indexOf('http') > -1;

export const targetFromUrl = (url) => {
  return isExternalUrl(url) ? '_blank' : '_self';
};
